import { DashboardsFilter } from '../generated/resolvers'
import request from '../requesters/search'

export const dashboardsFiltersDiscovery = async () => {
  const response = await request.get<DashboardsFilter>('/discovery/dashboards')

  return response.data || null
}
